import { isDefined } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { selectEffectiveYear } from '../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { PropertyGridForm } from '../../types.ts';
import { readOnlyFieldProps } from '../styles.ts';
import { PropertyGridFieldProps } from '../types.ts';
import { formatAgeWithYearBuilt } from '../utils.tsx';

export const AgeWithYearBuiltReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  control,
}: PropertyGridFieldProps) => {
  const { fieldName } = field;
  const effectiveYear = useAppSelector(selectEffectiveYear);

  const propertyDataFieldName =
    `columns.${columnIndex}.propertyData.${fieldName}` as FieldPath<PropertyGridForm>;
  const rawValue = useWatch({ control, name: propertyDataFieldName }) as
    | string
    | number
    | undefined;

  let numericValue: number | undefined;
  if (isDefined(rawValue)) {
    numericValue = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);
  }

  const displayValue =
    isDefined(numericValue) && !Number.isNaN(numericValue)
      ? formatAgeWithYearBuilt(numericValue, effectiveYear)
      : undefined;

  return <Typography {...readOnlyFieldProps(colSpan)}>{displayValue}</Typography>;
};
